import moment from 'moment'
import { Directive, ElementRef, Input } from '@angular/core'

@Directive({
  selector: '[expirable]',
})
export class ExpirableDirective {
  @Input() expirable: any

  constructor (
    private element: ElementRef<HTMLElement>,
  ) { }

  ngOnInit () {
    this.highlight()
  }

  ngOnChanges () {
    this.highlight()
  }

  highlight () {
    if (!this.expirable) {
      return
    }
    const expired = moment(this.expirable).diff(moment(), 'days') < 0

    this.element.nativeElement.classList.toggle('expired', expired)
    this.element.nativeElement.classList.toggle('not-expired', !expired)
  }
}
